/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:07:07
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/toast.js
 */
export default {
    // toast组件
    toast: {
        zIndex: 10090,
        loading: false,
        message: '',
        icon: '',
        type: '',
        loadingMode: '',
        show: '',
        overlay: false,
        position: 'center',
        params: {},
        duration: 2000,
        isTab: false,
        url: '',
        callback: null,
        back: false
    }

}
